/**
 * world 领域的 GameState 分片注册（世界状态与时间）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { WorldStateSchema, type WorldState } from './types/world';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    world?: WorldState;
  }
}

registerGameStateSlice('world', WorldStateSchema.optional(), () => ({
  unlockedAreas: ['starting_region'],
  sites: [],
  siteContentPlans: {},
  semanticQuestSiteRuntime: {},
  persistedItemTemplates: {},
  persistedTagDefinitions: {},
  flags: {},
  time: { year: 1223, season: 'spring', month: 1, day: 1, hour: 10, minute: 0 },
  weather: 'sunny',
  environment: {
    manaDensity: 1.0,
  },
}));
